module.exports = __webpack_public_path__ + "img/Mastercard.d93ec240.jpg";